import { Outlet } from 'react-router-dom';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { PageContainer } from '@toolpad/core/PageContainer';

const HiddenLayout = () => {
    return (
        <DashboardLayout hideNavigation>
            <PageContainer>
                <Outlet />
            </PageContainer>
        </DashboardLayout>
    );
}

export default HiddenLayout